
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacInput extends Vue {
  @Prop({ default: '' }) placeholer!: string;
  @Prop({ default: '' }) value!: string;

  get placeholderInPlace () {
    return this.placeholer ?? ''
  }
}
